export enum UserRole {
  PendingApproval = 'pending-approval',
  Administrator = 'administrator',
  FullUser = 'full-user',
  Guest = 'guest',
  Superuser = 'superuser',
  Deleted = 'deleted',
}
